import { DataTable } from "@/components/datatable/datatable"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { Page, PageTitle } from "@/components/page"
import { Button } from "@/components/ui/button"
import { supabase } from "@/lib/data"
import { Box, Folder, Plus, Trash2 } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { usePermissions } from "@/lib/hooks/usePermissions"

export const projects = {
  title: "Projects",
  description: "Manage your organization's projects and team assignments.",
  route: "/settings/projects",
  url: "/settings/projects",
  icon: Folder,
  component,
  group: "settings",
  resource: "projects",
  action: "read",
} satisfies PageConfig

const columns: Columns<Table<"projects">> = {
  name: { header: "Name", size: 200 },
  description: { header: "Description", size: 550 },
  status: { header: "Status", size: 100 },
  team: { header: "Team", size: 200, cell: ({ row }) => row.original.team?.["name"] },
  created_at: { header: "Model", size: 200, cell: DataTable.cellRender.date, },
}

function component() {

  const navigate = useNavigate()
  const { canCreate, canDelete } = usePermissions()

  const menu: DropdownMenuContents = [
    ...(canDelete("projects") ? [{
      title: "Delete", action: async (v) => {
        await supabase.from("projects").delete().eq("id", v.id)
      },
      icon: <Trash2 />,
      ask: "Are you sure you want to delete this Project?",
    }] : []),
  ]


  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
        <div className="grow"></div>
        {canCreate("projects") && <div>
          <Button className="rounded-lg" onClick={() => navigate('/settings/projects/new')}><Plus className="h-4 w-4" />New Project</Button>
        </div>}
      </div>
      <DataTableSupabase
        table="projects"
        columns={columns}
        showSelection
        onRowClick={"/settings/projects"}
        sort={["created_at", "desc"]}
        actions={menu.length > 0 ? menu : undefined}
        select={`
        *,
        team (
          name
        )
      `}
        enableServerSideFiltering={true}
        searchableColumns={["name", "description"]}
      />
    </div>
  </Page>

}

